import React, { Component } from "react";
import Cookie from "js-cookie";

import * as Image from "../../../../../assets/js/image";
import {
  httpPostDeleteUploadedFile,
  httpGetDocumentCenterSignedUrl,
  httpGetNotificationSignedUrl,
  httpGetFileContent,
} from "../../../../../service/httpClient";
import { getUserRolePermission } from "../../../../../utils/rolePermissionAccess";
import * as RolePermissionConstants from "../../../../../constants/RolePermissionConstants";
import DeleteDocumentModal from "./DeleteDocument/DeleteDocumentModal";
import DocumentDeleteErrorModal from "./DeleteDocument/DocumentDeleteErrorModal";
import * as Constants from "../../../../../constants/Constants";
import "./DownloadRenderer.css";

export default class DownloadRenderer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openDeleteModalFlag: false,
      showDocumentDeleteErrorModal: false,
      roleName: JSON.parse(localStorage.getItem(RolePermissionConstants.ROLES))
        .roleName,
      emailId: JSON.parse(localStorage.getItem(RolePermissionConstants.ROLES))
        .emailId,
    };
  }

  toggleDeleteModal = () => {
    this.setState({ openDeleteModalFlag: !this.state.openDeleteModalFlag });
  };

  allowDownload = () => {
    let status = true;

    if (this.props.disableAction) {
      return false;
    }
    const fileType = this.props.data?.fileType;

    if (fileType === Constants.DOCUMENT_TYPE_W9) {
      /**
       * For externalVendorGeneric check for emails and duns
       * If the logged in user has not uploaded the email and
       * secondary vendor is not associated with the duns,
       * restrict document delete.
       */
      if (
        (this.state.roleName === Constants.EXTERNAL_VENDOR_GENERIC ||
          this.state.roleName === Constants.EXTERNAL_GENERIC_ADMIN) &&
        this.state.emailId?.toLowerCase() !==
          this.props.data?.email?.toLowerCase() &&
        this.props.duns !== this.props.data?.duns
      ) {
        return false;
      }

      const permission = getUserRolePermission(
        RolePermissionConstants.VENDORPLATFORM_PREBOARDING_DOCUMENTCENTER,
        RolePermissionConstants.VMP_W9DOWNLOAD
      );

      if (permission === RolePermissionConstants.EDIT) {
        return true;
      }

      status = false;
    }
    if (
      (this.state.roleName === Constants.EXTERNAL_VENDOR_GENERIC ||
        this.state.roleName === Constants.EXTERNAL_GENERIC_ADMIN) &&
      fileType === Constants.DOCUMENT_TYPE_FRIEGHT_TERMS
    ) {
      return false;
    }

    return status;
  };

  shouldDeleteButtonVisible = () => {
    let status = true;
    const { data = {} } = this.props;
    const { notificationType = "" } = data;
    if (
      data.hasOwnProperty("isAllowToDelete") &&
      data.fileType === Constants.MBE_WBE_BUSINESSDOCUMENTATION &&
      !data.isAllowToDelete
    ) {
      return false;
    }

    if (
      ((this.state.roleName === Constants.EXTERNAL_VENDOR_GENERIC ||
        this.state.roleName === Constants.EXTERNAL_GENERIC_ADMIN) &&
        this.state.emailId?.toLowerCase() !==
          this.props.data?.email?.toLowerCase()) ||
      notificationType === "resource" ||
      notificationType === "notification"
    ) {
      status = false;
    }

    return status;
  };

  deleteDocument = () => {
    let formData = new FormData();
    const { data } = this.props;
    const { vendorDocumentId = "", vendorId = "" } = data || {};

    const payloadRequest = {
      documentId: vendorDocumentId,
      emailId: Cookie.get("email"),
    };

    for (let [key, value] of Object.entries(payloadRequest)) {
      if (!formData.has(key)) {
        formData.append(key, value);
      } else {
        formData.set(key, value);
      }
    }

    this.props.setFetching(true);
    httpPostDeleteUploadedFile(formData)
      .then((response) => {
        this.props.fetchData(vendorId);
        this.props.dataRefreshHandler(vendorId);
        this.toggleDeleteModal();
        Array.from(formData.keys()).forEach((key) => formData.delete(key));
      })
      .catch((error) => {
        console.log(error);
        this.toggleDeleteModal();
        Array.from(formData.keys()).forEach((key) => formData.delete(key));
        this.props.setFetching(false);
      });
  };

  checkIfDeleteIsPermitted = () => {
    const email = this.props.data?.email;

    if (
      email.includes("macys.mirakl") ||
      email.includes("bloomingdales.mirakl")
    ) {
      return false;
    }
    const fileType = this.props.data?.fileType;
    let permission = RolePermissionConstants.NONE;

    // Only for W9 document
    if (fileType === Constants.DOCUMENT_TYPE_W9) {
      /**
       * For externalVendorGeneric check for emails
       * If the logged in user has not uploaded the email,
       * restrict document delete.
       */
      if (
        (this.state.roleName === Constants.EXTERNAL_VENDOR_GENERIC ||
          this.state.roleName === Constants.EXTERNAL_GENERIC_ADMIN) &&
        this.state.emailId?.toLowerCase() !==
          this.props.data?.email?.toLowerCase()
      ) {
        return false;
      }

      permission = getUserRolePermission(
        RolePermissionConstants.VENDORPLATFORM_PREBOARDING_DOCUMENTCENTER,
        RolePermissionConstants.VMP_W9DELETE
      );
    } else {
      permission = getUserRolePermission(
        RolePermissionConstants.VENDORPLATFORM_PREBOARDING_DOCUMENTCENTER,
        RolePermissionConstants.VMP_DELETE
      );
    }

    const isDocumentRequired = this.props.data.required;

    if (permission === RolePermissionConstants.EDIT && !isDocumentRequired) {
      return true;
    }

    return false;
  };

  getDeleteClassName = () => {
    if (this.props.disableAction) {
      return "anchorLink_disabled";
    }
    const email = this.props.data?.email;

    if (
      email.includes("macys.mirakl") ||
      email.includes("bloomingdales.mirakl")
    ) {
      return "anchorLink_disabled";
    }
    const fileType = this.props.data?.fileType;
    let permission = RolePermissionConstants.NONE;

    // Only for W9 document
    if (fileType === Constants.DOCUMENT_TYPE_W9) {
      /**
       * For externalVendorGeneric check for emails
       * If the logged in user has not uploaded the email,
       * disable the delete icon.
       */
      if (
        (this.state.roleName === Constants.EXTERNAL_VENDOR_GENERIC ||
          this.state.roleName === Constants.EXTERNAL_GENERIC_ADMIN) &&
        this.state.emailId?.toLowerCase() !==
          this.props.data?.email?.toLowerCase()
      ) {
        return "anchorLink_disabled";
      }

      permission = getUserRolePermission(
        RolePermissionConstants.VENDORPLATFORM_PREBOARDING_DOCUMENTCENTER,
        RolePermissionConstants.VMP_W9DELETE
      );
    } else {
      permission = getUserRolePermission(
        RolePermissionConstants.VENDORPLATFORM_PREBOARDING_DOCUMENTCENTER,
        RolePermissionConstants.VMP_DELETE
      );
    }

    return permission === RolePermissionConstants.EDIT
      ? "anchorLink_enabled"
      : "anchorLink_disabled";
  };

  /*
   * Get the download link attributes based on document type.
   * Add onClick handler and pass the type of document
   * in order to override the default link behaviour.
   */
  getDownloadLinkAttributes = (
    isNotificationResourceType,
    documentUrl,
    docName
  ) => {
    let documentId = null;

    // Default for notification or resource
    let downloadLinkAttributes = {
      id: "download",
      href: documentUrl,
      download: docName,
      style:
        documentUrl === null || documentUrl === "" || !this.allowDownload()
          ? { pointerEvents: "none" }
          : { cursor: "pointer" },
    };

    if (isNotificationResourceType) {
      // Resource and notification page
      documentId = this.props?.data?.notificationId || "";
      downloadLinkAttributes = {
        ...downloadLinkAttributes,
        style:
          !documentId || !this.allowDownload()
            ? { pointerEvents: "none" }
            : { cursor: "pointer" },
        onClick: (e) =>
          this.handleDownloadFile(e, "notification", documentId, docName),
      };
    } else {
      // Document center page
      documentId = this.props?.data?.vendorDocumentId || "";
      downloadLinkAttributes = {
        ...downloadLinkAttributes,
        style:
          !documentId || !this.allowDownload()
            ? { pointerEvents: "none" }
            : { cursor: "pointer" },
        onClick: (e) =>
          this.handleDownloadFile(e, "documentCenter", documentId),
      };
    }

    return downloadLinkAttributes;
  };

  /*
   * Get the Download Icon based.
   * Enabled or disabled based on the documentUrl or documentId availability.
   * Also checks the delete permission.
   */
  getDownloadLinkImage = (isNotificationResourceType) => {
    let documentId = null;
    let DeleteComponent = null;

    if (isNotificationResourceType) {
      // Default for notification or resource
      documentId = this.props?.data?.notificationId || "";
    } else {
      // Document center
      documentId = this.props?.data?.vendorDocumentId || "";
    }

    if (!documentId || !this.allowDownload()) {
      DeleteComponent = Image.DISABLED_DOWNLOAD_ICON;
    } else {
      DeleteComponent = Image.DOWNLOAD_ICON;
    }

    return (
      <DeleteComponent style="w-10" altText="download-icon" id="download" />
    );
  };

  /**
   * Fetch the Signed URL using documentId.
   * The content of the Signed URL is downloaded.
   */
  handleDownloadFile = (e, type, documentId, docName) => {
    e.preventDefault();

    if (documentId) {
      if (type === "documentCenter") {
        let userEmail = Cookie.get("email").toLowerCase();
        (async () => {
          try {
            const res = await httpGetDocumentCenterSignedUrl(
              encodeURIComponent(documentId),
              userEmail
            );
            if (res.status === 200 && res.data) {
              await this.downloadFileContent(documentId, res.data);
            } else {
              throw new Error("Signed URL cannot be fetched.");
            }
          } catch (error) {
            console.log(error);
          }
        })();
      } else {
        (async () => {
          try {
            const res = await httpGetNotificationSignedUrl(documentId);
            if (res.status === 200 && res.data) {
              await this.downloadFileContent(docName, res.data);
            } else {
              throw new Error("Signed URL cannot be fetched.");
            }
          } catch (error) {
            console.log(error);
          }
        })();
      }
    }
  };

  /**
   * Download the content of the Signed URL.
   * A NodeJS endpoint is invoked to avoid CORS issues,
   * which sends the content of the file.
   * The binary content is converted to blob and downloaded in the client.
   * Any URL can be passed to this endpoint to download it's content.
   */
  downloadFileContent = async (documentId, url) => {
    // Get file content as blob
    const res = await httpGetFileContent(encodeURIComponent(btoa(url)));
    const blob = await res.blob();

    // Download the file
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = documentId;
    link.click();
  };

  checkConsigemnetVendorExternalGeneric = () => {
    return (
      (this.state.roleName === Constants.EXTERNAL_VENDOR_GENERIC ||
        this.state.roleName === Constants.EXTERNAL_GENERIC_ADMIN) &&
      this.props.data.fileType === Constants.CONSIGNMENT_CONTRACT_FIRST_DRAFT
    );
  };

  render() {
    const isNotificationResourceType =
      this.props?.data?.notificationType === "notification" ||
      this.props?.data?.notificationType === "resource";

    const documentUrl = isNotificationResourceType
      ? this.props?.data?.documentUrl
      : "";
    const docName = isNotificationResourceType
      ? this.props?.data?.documentName
      : "";

    let downloadLinkAttributes = this.getDownloadLinkAttributes(
      isNotificationResourceType,
      documentUrl,
      docName
    );

    return (
      <>
        {this.state.openDeleteModalFlag && (
          <DeleteDocumentModal
            open={this.state.openDeleteModalFlag}
            toggleDeleteModal={this.toggleDeleteModal}
            deleteDocument={this.deleteDocument}
          />
        )}
        {this.state.showDocumentDeleteErrorModal && (
          <DocumentDeleteErrorModal
            open={this.state.showDocumentDeleteErrorModal}
            documentName={this.props.data.documentName}
            fileType={this.props.data.fileType}
            toggleModal={() =>
              this.setState({
                showDocumentDeleteErrorModal: false,
              })
            }
          />
        )}
        {!this.checkConsigemnetVendorExternalGeneric() && (
          <a {...downloadLinkAttributes}>
            {this.getDownloadLinkImage(isNotificationResourceType)}
          </a>
        )}
        {!this.checkConsigemnetVendorExternalGeneric() &&
          this.shouldDeleteButtonVisible() && (
            <a
              id="delete"
              onClick={() => {
                if (this.props.disableAction) {
                  return false;
                }
                this.checkIfDeleteIsPermitted()
                  ? this.toggleDeleteModal()
                  : this.setState({ showDocumentDeleteErrorModal: true });
              }}
              className={this.getDeleteClassName()}
            >
              <Image.DELETE_ICON
                style="w-20 m-left-10"
                altText="delete-icon"
                id="deleteImage"
              />
            </a>
          )}
      </>
    );
  }
}
